var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
import classNames from "classnames";
import throttle from "lodash/throttle";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { stickyDrawerCls, stickyDrawerWrapperCls } from "./Drawer.less";
function StickyDrawer(_ref) {
  var _ref$skip = _ref.skip, skip = _ref$skip === void 0 ? false : _ref$skip, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, _ref$toggleDelta = _ref.toggleDelta, toggleDelta = _ref$toggleDelta === void 0 ? 50 : _ref$toggleDelta, _ref$disable = _ref.disable, disable = _ref$disable === void 0 ? false : _ref$disable, className = _ref.className, fixedPositionClassName = _ref.fixedPositionClassName, onChange = _ref.onChange, children = _ref.children;
  var DIRECTION = {
    UP: "up",
    DOWN: "down"
  };
  var elementRef = useRef(null);
  var _useState = useState("relative"), _useState2 = _slicedToArray(_useState, 2), position = _useState2[0], setPosition = _useState2[1];
  var _useState3 = useState(0), _useState4 = _slicedToArray(_useState3, 2), height = _useState4[0], setHeight = _useState4[1];
  var _useState5 = useState({
    position: null,
    top: null
  }), _useState6 = _slicedToArray(_useState5, 2), direction = _useState6[0], setDirection = _useState6[1];
  var _useState7 = useState(0), _useState8 = _slicedToArray(_useState7, 2), top = _useState8[0], setTop = _useState8[1];
  var delta = direction.top !== null && Math.abs(direction.top - top) || 0;
  var isFixed = !!(position === "fixed" && height);
  var isVisible = disable || direction.position === DIRECTION.UP && (delta > toggleDelta || Math.abs(top) <= height) || direction.position === DIRECTION.DOWN && Math.abs(top) <= height;
  var calcStyles = isFixed ? {
    top: isVisible ? 0 : -height
  } : null;
  var handleScroll = useCallback(function() {
    if (skip) {
      return;
    }
    var elm = elementRef.current.getBoundingClientRect();
    setHeight(elm.height);
    if (position !== "fixed" && elm.top < 0) {
      setPosition("fixed");
    }
    if (position === "fixed" && elm.top >= 0) {
      setPosition("relative");
    }
    if (top !== elm.top) {
      var newPosition = top < elm.top ? DIRECTION.UP : DIRECTION.DOWN;
      setDirection({
        position: newPosition,
        top: newPosition !== direction.position ? elm.top : direction.top
      });
    }
    setTop(elm.top >= 0 ? 0 : elm.top);
  }, [skip, position, top, direction.top, direction.position, DIRECTION.UP, DIRECTION.DOWN]);
  useEffect(function() {
    var delayedCalcSate = delay ? throttle(handleScroll, delay) : handleScroll;
    window.addEventListener("scroll", delayedCalcSate);
    handleScroll();
    return function() {
      return window.removeEventListener("scroll", delayedCalcSate);
    };
  }, [delay, handleScroll]);
  useEffect(function() {
    if (typeof onChange === "function") {
      onChange({
        position,
        direction,
        height,
        top,
        isFixed,
        isVisible
      });
    }
  }, [onChange, position, direction, height, top, isFixed, isVisible]);
  useEffect(function() {
    if (skip) {
      setPosition("relative");
    }
  }, [skip]);
  return /* @__PURE__ */ React.createElement("div", _extends({
    className: classNames(stickyDrawerCls, isFixed && fixedPositionClassName, className),
    ref: elementRef
  }, isFixed ? {
    style: {
      height
    }
  } : null), /* @__PURE__ */ React.createElement("div", {
    className: stickyDrawerWrapperCls,
    style: _objectSpread({
      position
    }, calcStyles)
  }, children));
}
__name(StickyDrawer, "StickyDrawer");
export {
  StickyDrawer
};
